import {Alert, Box, Button, Grid, Group} from "@mantine/core";
import {IconCheck, IconX} from "@tabler/icons-react";
import Modal, { Props as ModalProps } from "./Modal";
import { client } from "../../lib/axiosClient";
import { Notyf } from "notyf";
import { useEffect, useState } from "react";
import { notifications } from "@mantine/notifications";

import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";

const cookies = new Cookies(null, { path: '/' });
const {Col} = Grid

type Props = {
    setSelectedData?: (id: string) => void;
    data?: any;
    refetchData?: () => void;
} & ModalProps;


export const ChangeStatusInvoice = ({data, ...props}: Props) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const onFormSubmit = () => {
        setLoading(true)

        client.put(`/invoice/${data?.id}`, {
            "status": data?.status
        }, {
            headers: {
                'Accept': 'application/json',
                'Authorization': cookies.get('token') || ""
            }
        })
        .then(({data}) => {
            notifications.show({ message: "", color: '#fff' });
            setLoading(false)
            typeof props?.refetchData == "function" && props?.refetchData()
            closeModal()
        })
        .catch((error) => {
            notifications.show({ message: "", color: '#fff' });
            setLoading(false)
            closeModal()
        });
    };


    const closeModal = () => {
        props.onClose();
        setLoading(false)
    };
    
    return (
        <Modal
            {...props} onClose={closeModal} loading={loading} size="lg"
            footer={
                <Box py={16} px={20} bg="slate.0">
                    <Group justify={"flex-end"} gap={"xs"}>
                        <Button color={'gray'} variant="outline" rightSection={<IconX size={15} />} bg="white" onClick={closeModal}>{t('modals.cancelling')}</Button>
                        <Button rightSection={<IconCheck size={15} />} onClick={onFormSubmit} type={"button"}>
                            {data?.status === "confirmed" ? "قبول" : "رفض"}
                        </Button>
                    </Group>
                </Box>
            }
            title={data?.status === "confirmed" ? "قبول الطلب" : "رفض الطلب"}
        >
            <Box style={({ colors }) => ({padding: 20})}>
                <Grid gutter={20}>
                    <Col span={12} >
                        <Alert color={data?.status === "confirmed" ? "blue" : "red"}>
                            {"هل انت متأكد من"} {data?.status === "confirmed" ? "قبول" : "رفض"} {"الطلب؟"}
                        </Alert>
                    </Col>
                </Grid>
            </Box>
        </Modal>
    );
};